import { apiSlice } from '../../app/api/apiSlice'
import { generateFormatedURL } from "../urlFormatter";

const equipmentApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getEquipmentList: builder.query<any, any>({
            query: (args) => "/Equipment".concat(generateFormatedURL(args)),
        }),
        getEquipmentTypeDDL: builder.query<any, void>({
            query: () => "/Equipment/EquipmentTypeDDL"
        }),
        getRealTimeTypeDDL: builder.query<any, void>({
            query: () => "/Equipment/RealTimeTypeDDL"
        }),
        updateEquipment: builder.mutation({
            query: (formData) => {
                const id = formData.get('id');
                console.log(id);
                return {
                    url: id == 'undefined' || id == 'null' ? "/Equipment" : `/Equipment/${id}`,
                    method: id == 'undefined' || id == 'null' ? "POST" : "PUT",
                    body: formData,
                }
            }
        }),
        getEquipmentById: builder.query<any, string>({
            query: (id) => `/Equipment/${id}`
        }),
        getFile: builder.query<any, string>({
            query: (id) => {
                return {
                    url: `/Equipment/file/${id}`,
                    responseHandler: async (response) => {
                        const blob = await response.blob();
                        var blobUrl = URL.createObjectURL(blob);
                        return { url: blobUrl };
                    },
                }
            }
        }),
    })
})

export const {
    useLazyGetEquipmentListQuery,
    useLazyGetEquipmentTypeDDLQuery,
    useLazyGetRealTimeTypeDDLQuery,
    useUpdateEquipmentMutation,
    useLazyGetEquipmentByIdQuery,
    useLazyGetFileQuery,
} = equipmentApiSlice;